<template>
  <!-- prettier e as regras de template do Vue discordam neste arquivo -->
  <!-- eslint-disable vue/max-attributes-per-line, vue/html-indent, vue/html-closing-bracket-newline -->
  <header class="topbar" @keydown.esc="closeMenus">
    <!-- ============ Seletor de conta / workspace ============ -->
    <div class="tb-dd">
      <button class="tb-ws" @click.stop="toggleMenu('ws')">
        <span class="tb-ws-txt">
          <small>Conta</small>
          <b>{{ currentAccountName }}</b>
        </span>
        <svg class="ic ic-sm caret" viewBox="0 0 24 24">
          <path d="m6 9 6 6 6-6" />
        </svg>
      </button>

      <div v-if="activeMenu === 'ws'" class="menu menu-accounts">
        <div class="menu-label">Contas</div>
        <label v-if="showAccountSearch" class="acc-search" @click.stop>
          <svg class="ic ic-sm" viewBox="0 0 24 24">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
          </svg>
          <input
            ref="accSearchInput"
            v-model="accountQuery"
            type="text"
            placeholder="Buscar conta…"
          />
        </label>
        <div class="acc-list" @scroll="onAccScroll">
          <button
            v-for="account in visibleAccounts"
            :key="account.id"
            class="menu-item"
            @click="switchAccount(account.id)"
          >
            <span class="mi-txt">
              <b>{{ account.name }}</b>
              <small>{{ account.role || 'Membro' }}</small>
            </span>
            <svg
              v-if="account.id === accountId"
              class="ic ic-sm"
              style="color: #0a7581"
              viewBox="0 0 24 24"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
          </button>
          <div v-if="!filteredAccounts.length" class="acc-empty">
            Nenhuma conta encontrada
          </div>
          <div v-else-if="hasMoreAccounts" class="acc-more">
            Role para carregar mais ({{
              filteredAccounts.length - visibleAccounts.length
            }})
          </div>
        </div>
      </div>
    </div>

    <!-- ============ Busca global ============ -->
    <div class="tb-center">
      <label class="tb-search" @click="focusInputSearch">
        <svg class="ic ic-sm" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.3-4.3" />
        </svg>
        <input
          ref="searchInput"
          type="search"
          name="omnidesk-global-search"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          data-1p-ignore="true"
          data-lpignore="true"
          data-form-type="other"
          :readonly="!isFocused"
          :placeholder="searchPlaceholder"
          :value="searchQuery"
          @input="debounceSearch"
          @focus="handleFocusSearch"
          @blur="handleBlurSearch"
        />
        <span class="tb-kbd"><kbd>⌘</kbd><kbd>K</kbd></span>
      </label>
    </div>

    <!-- ============ Direita: Criar / Ajuda / Notificações / Usuário ============ -->
    <div class="tb-right">
      <!-- Fila de espera (contador + cronômetro) -->
      <queue-indicator :inbox-id="selectedInbox" :account-id="accountId" />

      <!-- + Criar -->
      <div class="tb-dd">
        <button
          class="tb-create"
          title="Criar"
          @click.stop="toggleMenu('create')"
        >
          <svg class="ic ic-sm" viewBox="0 0 24 24">
            <path d="M12 5v14M5 12h14" />
          </svg>
          <span class="tb-create-label">Criar</span>
          <svg class="ic ic-sm tb-create-caret" viewBox="0 0 24 24">
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>
        <div v-if="activeMenu === 'create'" class="menu right">
          <div class="menu-label">Atendimento</div>
          <button class="menu-item" @click="createAction('conversation')">
            <span class="mi-ico" style="background: #e1f8fb">
              <svg class="ic ic-sm" style="color: #0a7581" viewBox="0 0 24 24">
                <path
                  d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z"
                />
              </svg>
            </span>
            <span class="mi-txt"
              ><b>Nova conversa</b
              ><small>Iniciar atendimento ativo</small></span
            >
          </button>
          <button class="menu-item" @click="createAction('contact')">
            <span class="mi-ico" style="background: #e7f6ee">
              <svg class="ic ic-sm" style="color: #1f9d63" viewBox="0 0 24 24">
                <path
                  d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
                />
              </svg>
            </span>
            <span class="mi-txt"
              ><b>Novo contato</b><small>Cadastrar cliente/lead</small></span
            >
          </button>
          <div class="menu-sep" />
          <div class="menu-label">CRM</div>
          <button
            class="menu-item"
            :class="{ locked: !isCrmEnabled }"
            @click="isCrmEnabled && createAction('opportunity')"
          >
            <span class="mi-ico" style="background: #f0ecfe">
              <svg class="ic ic-sm" style="color: #7a5cf0" viewBox="0 0 24 24">
                <path d="M3 3v18h18" />
                <path d="m7 14 4-4 3 3 5-6" />
              </svg>
            </span>
            <span class="mi-txt"
              ><b>Nova oportunidade</b
              ><small>Adicionar ao funil de vendas</small></span
            >
            <span v-if="!isCrmEnabled" class="mi-lock">Upgrade</span>
          </button>
          <button
            class="menu-item"
            :class="{ locked: !isSurveyEnabled }"
            @click="isSurveyEnabled && createAction('survey')"
          >
            <span class="mi-ico" style="background: #fdf2e2">
              <svg class="ic ic-sm" style="color: #d98014" viewBox="0 0 24 24">
                <path
                  d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM23 21v-2a4 4 0 0 0-3-3.9M1 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2"
                />
              </svg>
            </span>
            <span class="mi-txt"
              ><b>Nova pesquisa</b><small>NPS / CSAT</small></span
            >
            <span v-if="!isSurveyEnabled" class="mi-lock">Upgrade</span>
          </button>
          <div class="menu-sep" />
          <button
            class="menu-item"
            :class="{ locked: !isCampaignFlowEnabled }"
            @click="isCampaignFlowEnabled && createAction('campaign')"
          >
            <span
              class="mi-ico"
              :style="{
                background: isCampaignFlowEnabled ? '#fdecec' : '#f0f3f5',
              }"
            >
              <svg
                class="ic ic-sm"
                :style="{
                  color: isCampaignFlowEnabled ? '#dc4b4b' : '#8a97a3',
                }"
                viewBox="0 0 24 24"
              >
                <path d="m3 11 18-5v12L3 14v-3Z" />
              </svg>
            </span>
            <span class="mi-txt"
              ><b>Nova campanha</b><small>Fluxo de campanhas</small></span
            >
            <span v-if="!isCampaignFlowEnabled" class="mi-lock">Upgrade</span>
          </button>
        </div>
      </div>

      <div class="tb-divider" />

      <!-- Ajuda -->
      <div class="tb-dd">
        <button class="tb-icon" title="Ajuda" @click.stop="toggleMenu('help')">
          <svg class="ic" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" />
            <path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01" />
          </svg>
        </button>
        <div v-if="activeMenu === 'help'" class="menu right">
          <button class="menu-item" @click="helpAction('help')">
            <span class="mi-ico">
              <svg class="ic ic-sm" viewBox="0 0 24 24">
                <path
                  d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2ZM22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7Z"
                />
              </svg>
            </span>
            <span class="mi-txt"><b>Central de ajuda</b></span>
          </button>
          <button class="menu-item" @click="helpAction('support')">
            <span class="mi-ico">
              <svg class="ic ic-sm" viewBox="0 0 24 24">
                <path
                  d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z"
                />
              </svg>
            </span>
            <span class="mi-txt"><b>Falar com o suporte</b></span>
          </button>
          <button class="menu-item" @click="helpAction('videos')">
            <span class="mi-ico">
              <svg class="ic ic-sm" viewBox="0 0 24 24">
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="M10 9l5 3-5 3V9Z" />
              </svg>
            </span>
            <span class="mi-txt"><b>Tutoriais em vídeo</b></span>
          </button>
          <div class="menu-sep" />
          <button class="menu-item" @click="openShortcuts">
            <span class="mi-ico">
              <svg class="ic ic-sm" viewBox="0 0 24 24">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <path d="M7 8h4M7 12h2" />
              </svg>
            </span>
            <span class="mi-txt"
              ><b>Atalhos de teclado</b><small>⌘ /</small></span
            >
          </button>
        </div>
      </div>

      <!-- Notificações -->
      <button
        class="tb-icon"
        title="Notificações"
        @click.stop="openNotificationPanel"
      >
        <svg class="ic" viewBox="0 0 24 24">
          <path
            d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0"
          />
        </svg>
        <span v-if="unreadCount" class="tb-dot">{{ unreadCount }}</span>
      </button>

      <div class="tb-divider" />

      <!-- Tema: claro / escuro / automático (US-4328) -->
      <div
        class="tb-theme"
        role="group"
        :aria-label="$t('PROFILE_SETTINGS.FORM.THEME.TITLE')"
      >
        <button
          class="tb-theme-opt"
          :class="{ active: themePreference === 'light' }"
          :title="$t('PROFILE_SETTINGS.FORM.THEME.LIGHT')"
          @click="setTheme('light')"
        >
          <svg class="ic ic-sm" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="4" />
            <path
              d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
            />
          </svg>
        </button>
        <button
          class="tb-theme-opt"
          :class="{ active: themePreference === 'dark' }"
          :title="$t('PROFILE_SETTINGS.FORM.THEME.DARK')"
          @click="setTheme('dark')"
        >
          <svg class="ic ic-sm" viewBox="0 0 24 24">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
          </svg>
        </button>
        <button
          class="tb-theme-opt tb-theme-auto"
          :class="{ active: themePreference === 'auto' }"
          :title="$t('PROFILE_SETTINGS.FORM.THEME.AUTO')"
          @click="setTheme('auto')"
        >
          Auto
        </button>
      </div>

      <div class="tb-divider" />

      <!-- Status de disponibilidade -->
      <div class="tb-dd">
        <button
          class="tb-status"
          :class="`st-${currentUserAvailability}`"
          :title="statusLabel"
          @click.stop="toggleMenu('status')"
        >
          <span class="st-dot" :style="{ background: statusColor }" />
          <span class="tb-status-label">{{ statusLabel }}</span>
          <svg class="ic ic-sm caret" viewBox="0 0 24 24">
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>
        <div v-if="activeMenu === 'status'" class="menu right menu-status">
          <div class="menu-label">
            {{ $t('SIDEBAR.SET_AVAILABILITY_TITLE') }}
          </div>
          <button
            v-for="s in availabilityStatuses"
            :key="s.value"
            class="menu-item status-item"
            @click="changeAvailabilityStatus(s.value)"
          >
            <span class="st-dot" :style="{ background: s.color }" />
            <span class="mi-txt"
              ><b>{{ s.label }}</b></span
            >
            <svg
              v-if="s.value === currentUserAvailability"
              class="ic ic-sm"
              style="color: #0a7581"
              viewBox="0 0 24 24"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
          </button>
          <div class="menu-sep" />
          <div class="menu-item auto-offline" @click.stop>
            <svg
              v-tooltip.left="$t('SIDEBAR.SET_AUTO_OFFLINE.INFO_TEXT')"
              class="ic ic-sm ao-info"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M12 16v-4M12 8h.01" />
            </svg>
            <span class="mi-txt ao-text">{{
              $t('SIDEBAR.SET_AUTO_OFFLINE.TEXT')
            }}</span>
            <button
              class="ao-switch"
              :class="{ on: currentUserAutoOffline }"
              @click.stop="toggleAutoOffline"
            >
              <span class="ao-knob" />
            </button>
          </div>
        </div>
      </div>

      <!-- Perfil do usuário -->
      <div class="tb-dd">
        <button class="tb-user" @click.stop="toggleMenu('user')">
          <span class="tb-user-av">
            {{ userInitial }}
            <span class="st" :style="{ background: statusColor }" />
          </span>
          <span class="tb-user-meta">
            <b>{{ userFirstName }}</b>
            <small>{{ statusLabel }}</small>
          </span>
          <svg class="ic ic-sm caret-user" viewBox="0 0 24 24">
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>
        <div v-if="activeMenu === 'user'" class="menu right">
          <div class="menu-user-head">
            <b>{{ currentUser.name }}</b>
            <small>{{ currentUser.email }}</small>
          </div>
          <div class="menu-sep" />
          <button class="menu-item" @click="userAction('profile')">
            <span class="mi-ico">
              <svg class="ic ic-sm" viewBox="0 0 24 24">
                <circle cx="12" cy="8" r="4" />
                <path d="M4 21a8 8 0 0 1 16 0" />
              </svg>
            </span>
            <span class="mi-txt"><b>Meu perfil</b></span>
          </button>
          <button class="menu-item" @click="userAction('settings')">
            <span class="mi-ico">
              <svg class="ic ic-sm" viewBox="0 0 24 24">
                <path
                  d="M20 7h-9M14 17H5M17 17a3 3 0 1 0 6 0 3 3 0 0 0-6 0ZM7 7a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z"
                />
              </svg>
            </span>
            <span class="mi-txt"
              ><b>Configurações</b
              ><small>Conta {{ currentAccountName }}</small></span
            >
          </button>
          <div class="menu-sep" />
          <button v-if="isSuperAdmin" class="menu-item" @click="openSuperAdmin">
            <span class="mi-ico">
              <svg class="ic ic-sm" viewBox="0 0 24 24">
                <path
                  d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3Z"
                />
                <path d="M9.5 12l1.8 1.8L15 10" />
              </svg>
            </span>
            <span class="mi-txt"><b>Console de Super Admin</b></span>
          </button>
          <button class="menu-item" @click="logout">
            <span class="mi-ico mi-ico--danger">
              <svg class="ic ic-sm" style="color: #dc4b4b" viewBox="0 0 24 24">
                <path
                  d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
                />
              </svg>
            </span>
            <span class="mi-txt"><b style="color: #dc4b4b">Sair</b></span>
          </button>
        </div>
      </div>
    </div>

    <woot-modal
      v-if="queryConversation"
      :show.sync="modalFilters"
      :on-close="closeModalFilters"
      size="small"
      custom-class="search-modal"
      @close="closeModalFilters"
    >
      <search-view @closeModal="closeModalFilters" />
    </woot-modal>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import { frontendURL } from '../../helper/URLHelper';
import SearchView from '../../modules/search/components/SearchView.vue';
import QueueIndicator from '../../components/widgets/conversation/QueueIndicator.vue';
import router from '..';
import { CONVERSATION_EVENTS } from '../../helper/AnalyticsHelper/events';
import { canAccessCRM } from '../../helper/crmPermissionHelper';
import Auth from '../../api/auth';
import uiSettingsMixin from '../../mixins/uiSettings';

const STATUS_MAP = {
  online: { label: 'Disponível', color: '#1f9d63' },
  busy: { label: 'Ocupado', color: '#f5a623' },
  offline: { label: 'Desconectado', color: '#7e8ea3' },
};
const AVAILABILITY_KEYS = ['online', 'busy', 'offline'];

// Quantas contas renderizar por vez no seletor (carrega mais ao rolar)
const ACCOUNTS_PAGE_SIZE = 30;
// A partir de quantas contas o campo de busca aparece
const ACCOUNTS_SEARCH_THRESHOLD = 6;

export default {
  name: 'HeaderApp',
  components: {
    SearchView,
    QueueIndicator,
  },
  mixins: [uiSettingsMixin],
  data() {
    return {
      activeMenu: null,
      searchQuery: '',
      isFocused: false,
      pageDefault: true,
      modalFilters: false,
      isNotificationPanel: false,
      accountQuery: '',
      accountsToShow: ACCOUNTS_PAGE_SIZE,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      selectedInbox: 'getSelectedInbox',
      currentUser: 'getCurrentUser',
      userAccounts: 'getUserAccounts',
      currentUserAvailability: 'getCurrentUserAvailability',
      notificationMetadata: 'notifications/getMeta',
      queryConversation: 'conversationSearch/getQueryConversation',
      getAccount: 'accounts/getAccount',
      currentUserAutoOffline: 'getCurrentUserAutoOffline',
      kanbanList: 'getKanbanfunnels',
    }),
    themePreference() {
      return this.uiSettings.color_scheme || 'auto';
    },
    account() {
      return this.getAccount(this.accountId);
    },
    availabilityStatuses() {
      const labels = this.$t(
        'PROFILE_SETTINGS.FORM.AVAILABILITY.STATUSES_LIST'
      );
      return AVAILABILITY_KEYS.map((value, i) => ({
        value,
        label: labels[i],
        color: STATUS_MAP[value].color,
      }));
    },
    // Módulos ativos na conta — mesma fonte da verdade do menu lateral
    // (booleans da conta, não a jsonb `features`).
    isCrmEnabled() {
      return canAccessCRM(this.account, this.currentUser, this.kanbanList);
    },
    isSurveyEnabled() {
      return !!this.account?.enable_smart_surveys;
    },
    isCampaignFlowEnabled() {
      return !!this.account?.enable_campaign_flow;
    },
    currentAccountName() {
      return (this.account && this.account.name) || 'Conta';
    },
    isSuperAdmin() {
      return this.currentUser?.type === 'SuperAdmin';
    },
    showAccountSearch() {
      return (this.userAccounts || []).length > ACCOUNTS_SEARCH_THRESHOLD;
    },
    filteredAccounts() {
      const accounts = this.userAccounts || [];
      // Divide em termos (busca por várias palavras, ordem indiferente)
      const tokens = this.normalizeText(this.accountQuery)
        .split(/\s+/)
        .filter(Boolean);
      if (!tokens.length) return accounts;
      return accounts.filter(acc => {
        const haystack = `${this.normalizeText(acc.name)} ${acc.id}`;
        return tokens.every(token => haystack.includes(token));
      });
    },
    visibleAccounts() {
      return this.filteredAccounts.slice(0, this.accountsToShow);
    },
    hasMoreAccounts() {
      return this.filteredAccounts.length > this.visibleAccounts.length;
    },
    userFirstName() {
      return (this.currentUser.name || '').split(' ')[0] || 'Usuário';
    },
    userInitial() {
      return (this.currentUser.name || 'U').charAt(0).toUpperCase();
    },
    statusLabel() {
      return (STATUS_MAP[this.currentUserAvailability] || STATUS_MAP.offline)
        .label;
    },
    statusColor() {
      return (STATUS_MAP[this.currentUserAvailability] || STATUS_MAP.offline)
        .color;
    },
    unreadCount() {
      const count = this.notificationMetadata.unreadCount;
      if (!count) return '';
      return count < 100 ? `${count}` : '99+';
    },
    searchPlaceholder() {
      return 'Buscar contatos, conversas, protocolos, oportunidades…';
    },
  },
  watch: {
    queryConversation: {
      handler(newValue) {
        this.searchQuery = newValue;
        if (newValue === 'close-modal') {
          this.closeModalFilters();
        }
      },
      immediate: true,
    },
    accountQuery() {
      // Ao filtrar, volta a mostrar a primeira "página" de resultados
      this.accountsToShow = ACCOUNTS_PAGE_SIZE;
    },
  },
  mounted() {
    document.addEventListener('click', this.onDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
  },
  methods: {
    // ----- Tema (US-4328) -----
    setTheme(value) {
      this.updateUISettings({ color_scheme: value });
    },
    // ----- Dropdowns -----
    toggleMenu(name) {
      this.activeMenu = this.activeMenu === name ? null : name;
      if (this.activeMenu === 'ws') {
        // Abriu o seletor de contas: limpa a busca, reinicia a paginação e foca
        this.accountQuery = '';
        this.accountsToShow = ACCOUNTS_PAGE_SIZE;
        this.$nextTick(() => {
          if (this.$refs.accSearchInput) this.$refs.accSearchInput.focus();
        });
      }
    },
    closeMenus() {
      this.activeMenu = null;
    },
    normalizeText(text) {
      // Minúsculas + remove acentos/diacríticos (á→a, ç→c, í→i, ã→a...)
      return (text || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    },
    onAccScroll(e) {
      const el = e.target;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 48;
      if (nearBottom && this.hasMoreAccounts) {
        this.accountsToShow += ACCOUNTS_PAGE_SIZE;
      }
    },
    onDocumentClick(e) {
      if (!this.$el.contains(e.target) || !e.target.closest('.tb-dd')) {
        this.closeMenus();
      }
    },
    // ----- Disponibilidade -----
    changeAvailabilityStatus(availability) {
      if (availability !== this.currentUserAvailability) {
        this.$store.dispatch('updateAvailability', {
          availability,
          account_id: this.accountId,
        });
      }
      this.closeMenus();
    },
    toggleAutoOffline() {
      this.$store.dispatch('updateAutoOffline', {
        accountId: this.accountId,
        autoOffline: !this.currentUserAutoOffline,
      });
    },
    // ----- Contas -----
    switchAccount(id) {
      this.closeMenus();
      if (id === this.accountId) return;
      window.location.href = `/app/accounts/${id}/conversation`;
    },
    // ----- Criar -----
    createAction(type) {
      this.closeMenus();
      const base = `accounts/${this.accountId}`;
      const routes = {
        conversation: `${base}/conversation`,
        contact: `${base}/contacts`,
        opportunity: `${base}/crm`,
        survey: `${base}/smart_survey`,
        campaign: `${base}/campaigns_flow`,
      };
      const path = routes[type];
      if (path) router.push({ path: frontendURL(path) });
    },
    // ----- Ajuda -----
    helpAction() {
      this.closeMenus();
    },
    openShortcuts() {
      this.closeMenus();
      this.$emit('open-key-shortcut-modal');
    },
    // ----- Usuário -----
    userAction(type) {
      this.closeMenus();
      const base = `accounts/${this.accountId}`;
      const routes = {
        profile: `${base}/profile/settings`,
        // Rota base de configurações: o redirect do 'settings_home' leva cada
        // papel ao destino acessível (admin/supervisor -> general, agente ->
        // canned-response). Cravar /settings/general bloqueava o agente — US-4407.
        settings: `${base}/settings`,
      };
      const path = routes[type];
      if (path) router.push({ path: frontendURL(path) });
    },
    openSuperAdmin() {
      this.closeMenus();
      // Rota servida pelo Rails (fora do SPA); abre em nova aba como no original.
      window.open('/super_admin', '_blank', 'noopener');
    },
    logout() {
      this.closeMenus();
      Auth.logout();
    },
    // ----- Notificações -----
    openNotificationPanel() {
      this.closeMenus();
      this.isNotificationPanel = true;
      if (this.$route.name !== 'notifications_index') {
        this.$emit('open-notification-panel');
      }
    },
    // ----- Busca -----
    handleFocusSearch() {
      this.isFocused = true;
    },
    handleBlurSearch() {
      this.isFocused = false;
    },
    focusInputSearch() {
      if (this.$refs.searchInput) this.$refs.searchInput.focus();
    },
    debounceSearch(e) {
      this.searchQuery = e.target.value;
      this.modalFilters = true;
      this.$store.dispatch('conversationSearch/setQuery', e.target.value);
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        if (this.searchQuery.length > 2 || this.searchQuery.match(/^[0-9]+$/)) {
          this.onSearch(this.searchQuery);
        }
      }, 500);
    },
    onSearch(q) {
      this.query = q;
      if (!q) {
        this.$store.dispatch('conversationSearch/clearSearchResults');
        this.closeModalFilters();
        return;
      }
      this.$track(CONVERSATION_EVENTS.SEARCH_CONVERSATION);
      this.$store.dispatch('conversationSearch/fullSearch', { q });
    },
    closeModalFilters() {
      this.$store.dispatch('conversationSearch/setQuery', '');
      this.modalFilters = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// Tema da barra superior (US-4328): cores via CSS vars locais; escuro
// sobrescreve. Valores claros ficam no seletor .topbar abaixo.
:root[data-theme='dark'] .topbar {
  --tb-surface: #16222e;
  --tb-surface-2: #101c26;
  --tb-border: #2a3a4d;
  --tb-border-strong: #35485d;
  --tb-text: #eef3f8;
  --tb-text-2: #9fb2c6;
  --tb-text-3: #7089a3;
  --tb-brand: #01c6d8;
  --tb-brand-050: rgba(1, 198, 216, 0.16);
  --tb-brand-600: #2ad4e4;
  --tb-brand-ink: #002136;
  --tb-navy: #002136;
}

// Chip do ícone "Sair" no menu do usuário: tinta vermelha escura no dark
// (no claro fica #fdecec). US-4328
:root[data-theme='dark'] .menu-item .mi-ico--danger {
  background: rgba(220, 75, 75, 0.16);
}

.topbar {
  // paleta clara (padrão) da barra superior
  --tb-surface: #ffffff;
  --tb-surface-2: #f0f3f5;
  --tb-border: #e4e9ee;
  --tb-border-strong: #d3dbe2;
  --tb-text: #0f1f2a;
  --tb-text-2: #516170;
  --tb-text-3: #8a97a3;
  --tb-brand: #01c6d8;
  --tb-brand-050: #e1f8fb;
  --tb-brand-600: #03b2c3;
  --tb-brand-ink: #002136;
  --tb-navy: #002136;
  height: 56px;
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--space-normal);
  background: var(--tb-surface);
  border-bottom: 1px solid var(--tb-border);
  padding: 0 var(--space-normal);
  color: var(--tb-text);
  z-index: 50;
}

.ic {
  width: 20px;
  height: 20px;
  flex: none;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.ic-sm {
  width: 16px;
  height: 16px;
}

// ---------- Seletor de conta ----------
.tb-ws {
  display: flex;
  align-items: center;
  gap: var(--space-one);
  padding: 5px 10px 5px 6px;
  border-radius: 10px;
  transition: background 0.15s ease-in-out;
  flex: none;
  cursor: pointer;

  &:hover {
    background: var(--tb-surface-2);
  }

  .caret {
    color: var(--tb-text-3);
  }
}
.tb-ws-txt {
  text-align: left;
  line-height: 1.15;

  small {
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: var(--tb-text-3);
    display: block;
  }
  b {
    font-size: 13px;
    font-weight: 700;
    color: var(--tb-text);
  }
}

// ---------- Busca ----------
.tb-center {
  flex: 1;
  display: flex;
  justify-content: center;
  min-width: 0;
}
.tb-search {
  display: flex;
  align-items: center;
  gap: var(--space-one);
  width: 100%;
  max-width: 52rem;
  background: var(--tb-surface-2);
  border: 1px solid var(--tb-border);
  border-radius: 10px;
  padding: 0 var(--space-slab);
  height: 38px;
  transition: background 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  cursor: text;

  &:hover {
    border-color: var(--tb-border-strong);
  }
  &:focus-within {
    background: var(--color-surface);
    border-color: var(--tb-brand);
    box-shadow: 0 0 0 3px var(--tb-brand-050);
  }

  svg {
    color: var(--tb-text-3);
  }
  input {
    flex: 1;
    min-width: 0;
    border: none;
    // !important: o input herda o pill do container; o override global de
    // fundo de inputs no dark (US-4328) não deve preenchê-lo.
    background: none !important;
    outline: none;
    color: var(--tb-text);
    font-size: 1.35rem;
    box-shadow: none !important;
    margin: 0;
    height: auto;

    &::placeholder {
      color: var(--tb-text-3);
    }
    &:focus {
      box-shadow: none !important;
    }
  }
  &:focus-within .tb-kbd {
    display: none;
  }
}
.tb-kbd {
  display: flex;
  gap: 3px;
  flex: none;

  kbd {
    font-size: 10px;
    font-weight: 600;
    color: var(--tb-text-3);
    background: var(--color-surface);
    border: 1px solid var(--tb-border);
    border-radius: 5px;
    padding: 2px 5px;
    line-height: 1;
  }
}

// ---------- Botão Criar ----------
.tb-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: none;
}
.tb-create {
  display: flex;
  align-items: center;
  gap: 7px;
  height: 38px;
  padding: 0 var(--space-slab);
  flex: none;
  background: var(--tb-brand);
  color: #fff;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease-in-out;

  &:hover {
    background: var(--tb-brand-600);
  }
}

// ---------- Ícones (ajuda / notificações) ----------
.tb-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  color: var(--tb-text-2);
  cursor: pointer;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out;
  position: relative;
  background: transparent;
  border: 0;

  &:hover {
    background: var(--tb-surface-2);
    color: var(--tb-text);
  }
}
.tb-dot {
  position: absolute;
  top: 6px;
  right: 7px;
  min-width: 16px;
  height: 16px;
  padding: 0 3px;
  background: var(--tb-brand);
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  border-radius: 8px;
  display: grid;
  place-items: center;
  border: 2px solid var(--tb-surface);
}
.tb-divider {
  width: 1px;
  height: 24px;
  background: var(--tb-border);
  margin: 0 4px;
}

// ---------- Seletor de tema (sol / lua / Auto) ----------
.tb-theme {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: 10px;
  background: var(--tb-surface-2);
}
.tb-theme-opt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  min-width: 30px;
  padding: 0 8px;
  border: 0;
  background: transparent;
  color: var(--tb-text-2);
  border-radius: 7px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out;

  &:hover {
    color: var(--tb-text);
  }

  &.active {
    background: var(--tb-surface);
    color: var(--tb-brand-600);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  }
}
.tb-theme-auto {
  letter-spacing: 0.01em;
}

// ---------- Usuário ----------
.tb-user {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 4px 8px 4px 4px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease-in-out;

  &:hover {
    background: var(--tb-surface-2);
  }
  .caret-user {
    color: rgba(15, 31, 42, 0.4);
  }
}
.tb-user-av {
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffb56b, #f78e3d);
  display: grid;
  place-items: center;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  flex: none;

  .st {
    position: absolute;
    bottom: -1px;
    right: -1px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    border: 2px solid var(--tb-surface);
  }
}
.tb-user-meta {
  text-align: left;
  line-height: 1.2;

  b {
    font-size: 12.5px;
    font-weight: 600;
    color: var(--tb-text);
    display: block;
  }
  small {
    font-size: 10.5px;
    color: var(--tb-text-3);
  }
}

// ---------- Dropdown genérico ----------
.tb-dd {
  position: relative;
}
.menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 25rem;
  background: var(--color-surface);
  border: 1px solid var(--tb-border);
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(16, 32, 45, 0.16);
  padding: 6px;
  z-index: 70;
  color: var(--tb-text);
  animation: menuIn 0.14s ease;

  &.right {
    left: auto;
    right: 0;
  }
}
@keyframes menuIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.menu-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--tb-text-3);
  padding: 8px 10px 4px;
}

// ---------- Seletor de contas: busca + lista rolável ----------
.menu-accounts {
  min-width: 28rem;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 8rem);
}
.acc-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 2px 4px 6px;
  padding: 0 10px;
  height: 34px;
  background: var(--tb-surface-2);
  border: 1px solid var(--tb-border);
  border-radius: 8px;
  cursor: text;

  &:focus-within {
    background: var(--color-surface);
    border-color: var(--tb-brand);
    box-shadow: 0 0 0 3px var(--tb-brand-050);
  }
  svg {
    color: var(--tb-text-3);
    flex: none;
  }
  input {
    flex: 1;
    min-width: 0;
    border: none;
    // !important: o input herda o pill do container; o override global de
    // fundo de inputs no dark (US-4328) não deve preenchê-lo.
    background: none !important;
    outline: none;
    color: var(--tb-text);
    font-size: 1.3rem;
    margin: 0;
    height: auto;
    box-shadow: none !important;

    &::placeholder {
      color: var(--tb-text-3);
    }
  }
}
.acc-list {
  overflow-y: auto;
  max-height: 34rem;
  margin: 0 -2px;
  padding: 0 2px;
}
.acc-empty {
  padding: 16px 10px;
  text-align: center;
  font-size: 12px;
  color: var(--tb-text-3);
}
.acc-more {
  padding: 8px 10px 4px;
  text-align: center;
  font-size: 10.5px;
  font-weight: 600;
  color: var(--tb-text-3);
}
.menu-user-head {
  padding: 8px 10px 4px;

  b {
    font-size: 13px;
    font-weight: 700;
    display: block;
  }
  small {
    font-size: 11px;
    color: var(--tb-text-3);
  }
}
.menu-item {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 13px;
  color: var(--tb-text);
  width: 100%;
  text-align: left;
  cursor: pointer;
  background: transparent;
  border: 0;
  transition: background 0.12s ease-in-out;

  &:hover {
    background: var(--tb-surface-2);
  }
  &.locked {
    opacity: 0.55;
    cursor: default;

    &:hover {
      background: transparent;
    }
  }

  .mi-ico {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: grid;
    place-items: center;
    flex: none;
    // Chip do ícone tema-aware (antes era #f0f3f5 fixo, invisível no dark). US-4328
    background: var(--tb-surface-2);

    &.mi-ico--danger {
      background: #fdecec;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }
  .mi-txt {
    flex: 1;
    min-width: 0;

    b {
      font-weight: 600;
      display: block;
    }
    small {
      font-size: 11px;
      color: var(--tb-text-3);
    }
  }
  .mi-lock {
    font-size: 9.5px;
    font-weight: 700;
    color: var(--tb-text-3);
    background: var(--tb-surface-2);
    padding: 2px 6px;
    border-radius: 5px;
  }
}
.menu-sep {
  height: 1px;
  background: var(--tb-border);
  margin: 6px 4px;
}

// ---------- Status de disponibilidade ----------
.tb-status {
  display: flex;
  align-items: center;
  gap: 7px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--tb-border);
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: 700;
  transition: filter 0.15s;
  flex: none;
}
.tb-status:hover {
  filter: brightness(0.96);
}
.tb-status .caret {
  opacity: 0.65;
}
.tb-status.st-online {
  background: #e7f6ee;
  color: #177a4a;
}
.tb-status.st-busy {
  background: #fdf2e2;
  color: #a8620f;
}
.tb-status.st-offline {
  background: #eef1f4;
  color: #516170;
}
// Pílulas de status no escuro: fundo translúcido colorido + texto claro
// (as versões claras acima são pasteis quase-brancos, destoam no dark). US-4328
:root[data-theme='dark'] .tb-status.st-online {
  background: rgba(0, 196, 29, 0.18);
  color: #6ee29e;
}
:root[data-theme='dark'] .tb-status.st-busy {
  background: rgba(230, 150, 30, 0.2);
  color: #e6b877;
}
:root[data-theme='dark'] .tb-status.st-offline {
  background: rgba(255, 255, 255, 0.08);
  color: var(--color-ink-soft);
}
.st-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex: none;
}
.menu-status {
  min-width: 24rem;
}
.status-item .st-dot {
  margin: 0 1px;
}
.auto-offline {
  gap: 8px;
  cursor: default !important;
}
.auto-offline:hover {
  background: transparent !important;
}
.auto-offline .ao-info {
  color: var(--tb-text-3);
  flex: none;
}
.auto-offline .ao-text {
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: var(--tb-text-2);
}
.ao-switch {
  position: relative;
  width: 36px;
  height: 20px;
  border-radius: 20px;
  background: var(--tb-border-strong);
  border: 0;
  flex: none;
  cursor: pointer;
  transition: background 0.15s;
  padding: 0;
}
.ao-switch.on {
  background: var(--tb-brand);
}
.ao-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--color-surface);
  box-shadow: 0 1px 2px rgba(16, 32, 45, 0.25);
  transition: transform 0.15s;
}
.ao-switch.on .ao-knob {
  transform: translateX(16px);
}

.search-modal {
  align-items: flex-start !important;
  margin-top: 56px !important;
}

// ============================================================
// Responsivo — desktop com telas menores. Prioriza a barra de
// busca colapsando os itens da direita em tiers. ADITIVO: só
// afeta larguras <= breakpoint; telas grandes ficam inalteradas.
// ============================================================

// Tier A — o botão "Criar" vira só o "+" (ícone), liberando área
// para a busca. A ação (abrir o menu) continua a mesma.
@media (max-width: 1366px) {
  .tb-create {
    width: 38px;
    padding: 0;
    gap: 0;
    justify-content: center;
  }
  .tb-create-label,
  .tb-create-caret {
    display: none;
  }
}

// Tier B — status vira um botão quadrado na cor do status (sem
// rótulo; o nome aparece no hover via title). Esconde a dica ⌘K e
// aperta espaçamentos para dar ainda mais área à busca.
@media (max-width: 1120px) {
  .topbar {
    gap: var(--space-small);
  }
  .tb-divider {
    margin: 0 1px;
  }
  .tb-kbd {
    display: none;
  }
  // Status colapsado: mesmo formato quadrado do "+ Criar" (38x38, cantos
  // de 10px herdados do padrão da pílula), MANTENDO o fundo colorido do
  // status (verde/laranja/cinza) — só esconde o texto e centraliza o
  // ponto. O nome aparece no hover (atributo title).
  .tb-status {
    width: 38px;
    padding: 0;
    gap: 0;
    justify-content: center;
  }
  .tb-status .st-dot {
    width: 11px;
    height: 11px;
  }
  .tb-status-label,
  .tb-status .caret {
    display: none;
  }
}
</style>
